import { types } from 'mobx-state-tree';
export const SubmeterBillFinalStateModel = types.model('SubmeterBillFinalStateModel', {
  allocationCharge: types.number,
  allocationCycleId: types.string,
  billingCycleId: types.string,
  buildingId: types.string,
  endMeterDateOnly: types.string,
  endMeterRead: types.number,
  id: types.string,
  isProcessed: types.boolean,
  meterRate: types.number,
  meterUsage: types.number,
  modifiedOn: types.string,
  propertyId: types.string,
  residentAccountId: types.string,
  residentAccountFullName: types.maybeNull(types.string),
  serviceDaysInPeriod: types.number,
  startMeterDateOnly: types.string,
  startMeterRead: types.number,
  transactionCreatedOnDateOnly: types.string,
  unitName: types.string,
  unitsOfMeasure: types.string,
  userEditedCsvFileId: types.maybeNull(types.string),
  userInitialCsvFileId: types.string,
  utilityId: types.string
}).actions(store => {
  return {
    setResidentAccountFullName(residentAccountFullName) {
      store.residentAccountFullName = residentAccountFullName;
    }
  };
});